export function OutlineSquareTextIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.0244 2.5918H5.02441C3.91984 2.5918 3.02441 3.48723 3.02441 4.5918V18.5918C3.02441 19.6964 3.91984 20.5918 5.02441 20.5918H19.0244C20.129 20.5918 21.0244 19.6964 21.0244 18.5918V4.5918C21.0244 3.48723 20.129 2.5918 19.0244 2.5918Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
      />
      <path d="M8.02441 10.5918V7.5918H16.0244V10.5918" stroke={stroke} strokeWidth={strokeWidth} />
      <path d="M12.0244 7.5918V16.5918" stroke={stroke} strokeWidth={strokeWidth} />
      <path d="M10.0244 15.5918H14.0244" stroke={stroke} strokeWidth={strokeWidth} />
    </svg>
  );
}
